
const autocompleteHandler    = require ('../textfield/autocomplete-handler')
const checkbox               = require ('../selector/checkbox')
const radio                  = require ('../selector/radio')
const textfieldHandler       = require ('../textfield/textfield-handler')
const textfieldMultiselect   = require ('../textfield/textfield-multiselect')



export function getValues(elem){  //console.log('getValues type>', elem.type, elem.name)
      
       return getValuesObj[elem.type].start(elem)

} //getValues


const getValuesObj = {
   
      autocomplete:      { start: (elem)=>{ return autocompleteHandler.getValue(elem.html);        }},
      checkbox:          { start: (elem)=>{ return checkbox.getValue(elem.html);                   }},
      multiselect:       { start: (elem)=>{ return textfieldMultiselect.getFromHtml(elem.html);    }},
      radio:             { start: (elem)=>{ return radio.getValue(elem.html);                      }},
      textfield:         { start: (elem)=>{ return textfieldHandler.getValue(elem);                }},
      textfieldValidator:{ start: (elem)=>{ return textfieldHandler.getValue(elem);                }},
}


export function fill(elem){ // console.log('getValues type>', elem.type)
      
       return fillObj[elem.type].start(elem)

} //getValues

const fillObj = {
   
      autocomplete:      { start: (elem)=>{  autocompleteHandler.fill(elem);                }},
      checkbox:          { start: (elem)=>{  checkbox.fill(elem.html, elem.value);          }},
      multiselect:       { start: (elem)=>{  textfieldMultiselect.createChoose(elem);       }},
      radio:             { start: (elem)=>{  radio.fill(elem.html, elem.value);             }},
      textfield:         { start: (elem)=>{  textfieldHandler.fill(elem.html, elem.value);  }},
      textfieldValidator:{ start: (elem)=>{  textfieldHandler.fill(elem.html, elem.value);  }},
}



export function clean(elem){  //console.log('getValues type>', elem.type)
      
       return cleanObj[elem.type].start(elem)

} //getValues

const cleanObj = {
   
      autocomplete:      { start: (elem)=>{  autocompleteHandler.clean({html:elem.html});      }},
      checkbox:          { start: (elem)=>{  checkbox.clean(elem.html);                        }},
      multiselect:       { start: (elem)=>{  textfieldMultiselect.createChoose(elem);          }},
      radio:             { start: (elem)=>{  radio.clean(elem.html);                           }},
      textfield:         { start: (elem)=>{  textfieldHandler.clean(elem.html);                }},
      textfieldValidator:{ start: (elem)=>{  textfieldHandler.clean(elem.html);                }},
      multiselect:       { start: (elem)=>{  textfieldMultiselect.createClean( elem);          }},

}






















